var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-uploader',{staticStyle:{"margin":"20px auto"},attrs:{"after-read":_vm.uploadFile}},[_c('van-button',{attrs:{"icon":"plus","type":"primary","native-type":"button"}},[_vm._v("附件上传")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }